const isUnitTesting = () => !!process.env.JEST_WORKER_ID;

export default isUnitTesting;
